// select.js — Auswahlfeld: das native <select> bleibt Quelle der Wahrheit (Formulare, change-Ereignis),
// sichtbar ist ein Auslöser + Menü (Liste am body, auf compact Bottom-Sheet).
//   <label class="vc-field"><select name="x">…</select><span class="vc-field-label">Land</span></label>
//   enhanceSelects(root)  — einmalig je Element
import { openMenu } from './menu.js';

export function enhanceSelect(select) {
  if (select._vc || select.multiple || select.dataset.native != null) return;
  select._vc = true;
  select.classList.add('is-enhanced');
  select.tabIndex = -1;
  select.setAttribute('aria-hidden', 'true');
  const field = select.closest('.vc-field');
  const label = field && field.querySelector('.vc-field-label');
  const trig = document.createElement('button');
  trig.type = 'button';
  trig.className = 'vc-select-trigger';
  trig.setAttribute('aria-haspopup', 'listbox');
  trig.setAttribute('aria-expanded', 'false');
  if (label) { label.id = label.id || 'vcsl' + Math.random().toString(36).slice(2, 8); trig.setAttribute('aria-labelledby', label.id + ' ' + (trig.id = 'vcst' + Math.random().toString(36).slice(2, 8))); }
  const text = document.createElement('span');
  trig.appendChild(text);
  select.after(trig);
  const sync = () => {
    const o = select.options[select.selectedIndex];
    text.textContent = o ? o.textContent : '';
    trig.disabled = select.disabled;
    if (field) field.classList.toggle('has-value', true);
  };
  const items = () => {
    const out = [];
    for (const node of select.children) {
      if (node.tagName === 'OPTGROUP') {
        out.push({ group: node.label });
        for (const o of node.children) out.push({ value: o.value, label: o.textContent, disabled: o.disabled });
      } else if (node.tagName === 'OPTION' && !node.hidden) out.push({ value: node.value, label: node.textContent, disabled: node.disabled });
    }
    return out;
  };
  trig.addEventListener('click', () => {
    if (trig.getAttribute('aria-expanded') === 'true') return;
    openMenu(field || trig, items(), { trigger: trig,
      role: 'listbox', selected: select.value, label: label ? label.textContent : undefined,
      onSelect: (v) => {
        if (v === select.value) return;
        select.value = v; sync();
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      },
    });
  });
  trig.addEventListener('keydown', (e) => {
    if (['ArrowDown', 'ArrowUp'].includes(e.key)) { e.preventDefault(); trig.click(); }
  });
  // Wert per Code gesetzt (select.value = …) → Anzeige nachziehen
  const proto = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value');
  Object.defineProperty(select, 'value', { configurable: true, get() { return proto.get.call(this); }, set(v) { proto.set.call(this, v); sync(); } });
  new MutationObserver(sync).observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  select.addEventListener('change', sync);
  sync();
}

export function enhanceSelects(root = document) {
  for (const s of root.querySelectorAll('.vc-field > select')) enhanceSelect(s);
}
